'use client'

import ListingsStandard from '@component/card/listings/standard'
import SectionSwiper from '@component/layout/section/swiper'
import { SkeletonContentBoxLine1 } from '@component/skeleton/contentBox'
import useFetch from '@hooks/useFetch'
import { useUnmount } from 'react-use'

export default function Recommended() {
  const { data, isLoading, cancel } = useFetch('houses/recommended-by-ip')

  useUnmount(() => {
    cancel()
  })

  if (isLoading) {
    return (
      <SkeletonContentBoxLine1 showTitle={false} className='' />
    )
  }

  return (
    <SectionSwiper
      data={data}
      dataKey='id'
      slideClassName='pb-8'
      swiperClassName='-mb-8'
      cardParams={{ showAgent: false }}
      Card={ListingsStandard}
    />
  )
}